import Change from "../components/Changes/Change";
import { changes, closedChanges } from "../endpoints";
import useFetch from "../hooks/useFetch";
import { useState } from "react";

import { useClickFilter } from "../hooks/filtering";
import { useSearchBar } from "../hooks/search";

interface data {
  number: string;
  description: string;
  client: string;
  status: string;
  requester: string;
  coordinator: string;
  type: string;
}

const ChangesLayout = () => {
  const [isOpen, setIsOpen] = useState(true);
  const endpoint = isOpen ? changes : closedChanges;
  const { data, loading } = useFetch<data>(endpoint);
  // const [filter, setFilter] = useState("");

  const {
    searchEntry,
    setSearchEntry,

    setIsSearchFocused,

    handleFilterClick,
    shouldShowFilters,
    searchRef,
    getFilteredSearchProjects,
  } = useSearchBar(data);

  const {
    descriptionSort,
    toggleDescriptionSort,

    clientSort,
    toggleClientSort,

    numberSort,
    toggleNumberSort,

    requesterSort,
    toggleRequesterSort,

    coordinatorSort,
    toggleCoordinatorSort,

    getArrow,
    getFilteredData,
  } = useClickFilter();

  // Combine search and click filters
  const getFilteredAndSortedData = () => {
    if (!data) return [];
    
    const searchFiltered = getFilteredSearchProjects();
    
    return getFilteredData(searchFiltered);
  };

  return (
    <div className="overflow-hidden w-full">
      {/* Header */}
      <div>
        <div className="flex justify-between">
          {/* Header Text */}
          <div>
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
              <h1 className="font-bold text-3xl sm:text-4xl">
                {loading ? (
                  <span className="text-gray-400">Wijzigingen laden...</span>
                ) : (
                  `Wijzigingen`
                )}
              </h1>
            </div>
            <p className="mt-4">
              {loading ? (
                <span className="text-gray-400">
                  Een moment geduld, de gegevens worden geladen.
                </span>
              ) : (
                "Hier een overzicht van alle wijzigingen"
              )}
            </p>
          </div>
          <div className="relative flex-1 flex justify-end" ref={searchRef}>
            {/* Search area */}
            <div className="bg-white w-[50%] h-12 rounded-3xl flex justify-center my-auto border border-gray-200">
              <input
                className="h-6 w-[80%] m-auto focus:outline-none"
                onChange={(e) => setSearchEntry(e.target.value)}
                onFocus={() => setIsSearchFocused(true)}
                value={searchEntry}
                placeholder="Zoeken..."
              />
            </div>

            {/* Filters */}
            {shouldShowFilters && (
              <div className="absolute top-full right-0 z-10 bg-white shadow-lg rounded-lg p-4 border border-gray-200 min-w-[50%] mt-2">
                <b className="text-gray-600 text-xs">Filters</b>
                <div
                  className="text-gray-600 text-sm p-2 cursor-pointer rounded-lg hover:bg-gray-100"
                >
                  <b>Geen specefieke filters mogelijk op het moment</b>
                  <div className="flex text-xs">
                    <b>Zoeken is wel mogelijk</b>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Data Table */}
        <div className="p-8 bg-white  rounded-xl mt-6 w-full overflow-auto">
          {data.length > 0 && !loading && (
            <div className="w-full text-gray-600 flex text-sm p-2 border-b-2">
              <div
                className="w-1/12 flex cursor-pointer select-none"
                onClick={toggleNumberSort}
              >
                <b>Nummer</b>
                {getArrow(numberSort) && (
                  <img
                    src={getArrow(numberSort)!}
                    className="h-5 w-auto ml-1"
                    alt=""
                  />
                )}
              </div>
              <div
                className="w-3/12 flex cursor-pointer select-none"
                onClick={toggleDescriptionSort}
              >
                <b>Beschrijving</b>
                {getArrow(descriptionSort) && (
                  <img
                    src={getArrow(descriptionSort)!}
                    className="h-5 w-auto ml-1"
                    alt=""
                  />
                )}
              </div>
              <div
                className="w-2/12 flex cursor-pointer select-none"
                onClick={toggleClientSort}
              >
                <b>Klant</b>
                {getArrow(clientSort) && (
                  <img
                    src={getArrow(clientSort)!}
                    className="h-5 w-auto ml-1"
                    alt=""
                  />
                )}
              </div>
              <b className="w-2/12 text-left">Status</b>
              <b className="w-1/12 text-left">Type</b>
              <div
                className="w-2/12 flex cursor-pointer select-none"
                onClick={toggleRequesterSort}
              >
                <b>Aanvrager</b>
                {getArrow(requesterSort) && (
                  <img
                    src={getArrow(requesterSort)!}
                    className="h-5 w-auto ml-1"
                    alt=""
                  />
                )}
              </div>
              <div
                className="w-2/12 flex cursor-pointer select-none"
                onClick={toggleCoordinatorSort}
              >
                <b>Coordinator</b>
                {getArrow(coordinatorSort) && (
                  <img
                    src={getArrow(coordinatorSort)!}
                    className="h-5 w-auto ml-1"
                    alt=""
                  />
                )}
              </div>
            </div>
          )}
          {loading ? (
            <div className="min-w-full bg-gray-200 p-4 font-semibold text-gray-700 dark:text-gray-300 rounded-xl mt-1 animate-pulse">
              <p>Wijzigingen laden...</p>
            </div>
          ) : data.length === 0 ? (
            <tr>
              <td
                colSpan={6}
                className="p-4 text-center text-gray-500 text-xl font-semibold"
              >
                Geen open wijzigingen
              </td>
            </tr>
          ) : (
            getFilteredAndSortedData().map((change, index) => (
              <Change
                key={index}
                number={change.number}
                description={change.description}
                client={change.client}
                status={change.status}
                requester={change.requester}
                coordinator={change.coordinator}
                type={change.type}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ChangesLayout;
